import { TypedStorage } from '@utils/typedStorage';

export const accessTokenStorage = new TypedStorage<string>('accessToken');
export const expirationDateStorage = new TypedStorage<number>('expirationDate');
